import { useEffect } from "react";
import { waitForAppFonts } from "../utils/appFonts";

function hasMuiEmotionStyles() {
  return Boolean(
    document.head.querySelector('style[data-emotion^="mui"]'),
  );
}

/**
 * Marks the document ready only after React + Emotion/MUI have committed styles
 * and Roboto Mono has finished loading, so the first visible paint is fully styled.
 */
export default function AppReadyGate() {
  useEffect(() => {
    let cancelled = false;

    const markReady = () => {
      if (!cancelled) {
        document.documentElement.classList.add("app-ready");
      }
    };

    const reveal = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(markReady);
      });
    };

    const waitForStyles = (attempts = 0) => {
      if (cancelled) return;
      if (hasMuiEmotionStyles() || attempts > 120) {
        waitForAppFonts().then(reveal).catch(reveal);
        return;
      }
      requestAnimationFrame(() => waitForStyles(attempts + 1));
    };

    waitForStyles();

    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
